import { Component, OnInit, Input } from '@angular/core';
import { textField } from './supply-invoice-reception-conditions-subscriptions';

import {
  SupplyInvoiceReceptionRequestType,
  RicezioneFattureFornitura,
} from '../../../models/fisso';

@Component({
  selector: 'alg-supply-invoice-reception-info-subscription',
  templateUrl:
    './alg-supply-invoice-reception-info-subscription.component.html',
  styleUrls: [
    './alg-supply-invoice-reception-info-subscription.component.scss',
  ],
})
export class AlgSupplyInvoiceReceptionInfoSubscriptionComponent {
  @Input() type: SupplyInvoiceReceptionRequestType;
  @Input() data: RicezioneFattureFornitura;
  @Input() email: string;

  public textField = textField;
  constructor() {}

  getText(): string {
    if (this.type == undefined) {
      return '';
    }
    switch (this.type) {
      case SupplyInvoiceReceptionRequestType.email2Email:
      case SupplyInvoiceReceptionRequestType.physical2physical:
        return textField.sameTypeAddress(
          this.email || '',
          this.data.modifiedAsset || '',
          this.type === SupplyInvoiceReceptionRequestType.email2Email,
          this.data.oldLayout,
          this.data.layout
        );
      case SupplyInvoiceReceptionRequestType.email2physical:
      case SupplyInvoiceReceptionRequestType.physical2email:
        return textField.changeTypeAddress(
          this.email || '',
          this.data.modifiedAsset || '',
          this.type === SupplyInvoiceReceptionRequestType.email2physical,
          this.data.oldLayout,
          this.data.layout
        );
      case SupplyInvoiceReceptionRequestType.changeLayout:
        return textField.changeLayout(
          this.data.modifiedAsset || '',
          this.data.layout
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-supply-invoice-reception-management/alg-supply-invoice-reception-info-subscription/alg-supply-invoice-reception-info-subscription.component.ts